import { Pipe, PipeTransform } from '@angular/core';
import { FieldValueViewModel } from '@vdms-hq/selectors';
import { SelectOption } from '@vdms-hq/shared';

@Pipe({
  name: 'fieldValueByTypeToSelectOptions',
  standalone: true,
})
export class FieldValueByTypeToSelectOptionsPipe implements PipeTransform {
  transform(fields: FieldValueViewModel[], type: string): SelectOption[] {
    return (fields ?? [])
      .filter((field) => field.type?.name === type)
      .map((field) => ({
        key: field.uuid,
        label: field.label,
      }));
  }
}
